import {useDropdown, useTriggerDisabled} from './hooks'
import {FloatingProvider, FloatingReferenceTrigger, useFloatingContext, FloatingFocusManager, FloatingTree} from '~/components'

const DropdownItems = ({children}) => {
	const {refs, floatingStyles, getFloatingProps, isOpen, maxWidth} = useFloatingContext()

	if (!isOpen) return null

	const floatingProps = getFloatingProps()
	const style = {...floatingStyles, maxWidth}

	return (
		<FloatingFocusManager>
			<div ref={refs.setFloating} className="dropdown-item-list" style={style} {...floatingProps}>
				{children}
			</div>
		</FloatingFocusManager>
	)
}

const Inner = ({
	ref,
	openAtCursorPosition,
	triggerEvent,
	isNested,
	placement = isNested ? 'right-start' : 'bottom-start',
	trigger,
	maxHeight = 400,
	maxWidth,
	children,
}) => {
	const triggerDisabled = useTriggerDisabled(trigger)
	const {floating, config, interactions} = useDropdown({
		placement,
		triggerEvent,
		openAtCursorPosition,
		isNested,
		maxHeight,
		triggerDisabled,
	})

	return (
		<FloatingProvider floating={floating} config={config} interactions={interactions} maxWidth={maxWidth}>
			<FloatingReferenceTrigger ref={ref} trigger={trigger} showRightArrowIfNested />
			<DropdownItems>{children}</DropdownItems>
		</FloatingProvider>
	)
}

export const Dropdown = props => {
	return (
		<FloatingTree>
			<Inner {...props} />
		</FloatingTree>
	)
}
